<template>
  <b-modal :visible="show" :hide-header="true" centered id="modal-custas-judiciais" size="md" :hide-footer="true">
    <div class="float-right"><img @click="hide" class="close-modal" src="img/x-modal.svg" /></div>
    <div class="text-justify mt-3">
      <!--
        Explicação da cobertura 5028 — texto vem de config.js (fonte única do app).
        Ver specs/001-avisos-legais-susep. NÃO reescrever a redação aqui.
      -->
      <h5 class="bold-modal">{{ texto.TITULO }}</h5>

      <div class="mb-3">{{ texto.INTRO }}</div>

      <div class="mb-3">
        <strong>{{ texto.SUBTITULO_EXEMPLOS }}</strong>
        <ul class="lista-exemplos mt-2">
          <li v-for="(item, i) in texto.ITENS" :key="i">{{ item }}</li>
        </ul>
      </div>

      <div class="mb-2">
        <strong>{{ texto.SUBTITULO_EXEMPLO_BIKE }}</strong>
        <div class="mt-2">{{ texto.EXEMPLO_BIKE }}</div>
      </div>

      <div class="center-modal mt-5">
        <button type="button" class="continue-btn-modal" @click="hide"> Entendi </button>
      </div>
    </div>
  </b-modal>
</template>
<script>
import config from "../../config";

export default {
  props: ["show"],
  data() {
    return { texto: config.EXPLICACAO_CUSTAS_JUDICIAIS };
  },
  methods: {
    hide() {
      this.$emit("hide");
    },
  },
};
</script>
<style>
#modal-custas-judiciais___BV_modal_content_ {
  border-radius: 12px !important;
  padding: 25px;
  padding-top: 15px;
  color: #78849E;
}

#modal-custas-judiciais___BV_modal_content_ .lista-exemplos {
  padding-left: 20px;
  margin-bottom: 0;
}
</style>
